<template>
  <v-container fluid class="fill-height">
    <Diagram
      class="fill-height"
      style="width: 100%"
      @onRightClick="displayFloatingMenu"
      @onNodeSelected="SET_SELECTED_NODE"
      @onNodeUnselected="SET_SELECTED_NODE(null)"
      @onConnectionCreated="disableNodeOutput"
      @onConnectionRemoved="enableNodeOutput"
    />

    <FloatingDiagramMenu />
  </v-container>
</template>

<script>
  import Diagram from '@/components/Diagram'
  import FloatingDiagramMenu from '@/components/FloatingDiagramMenu'
  import { mapGetters, mapMutations } from 'vuex'

  export default {
    name: 'Home',
    components: { FloatingDiagramMenu, Diagram },
    methods: {
      ...mapGetters([ 'isANodeSelected' ]),
      ...mapMutations([ 'SET_IS_MENU_DISPLAYED', 'SET_MENU_COORDINATES', 'SET_SELECTED_NODE' ]),
      displayFloatingMenu (e) {
        if (!this.isANodeSelected()) {
          e.preventDefault()
          this.SET_IS_MENU_DISPLAYED(false)

          // The offset will allow the new node to be positioned closer to where the menu was opened
          const coordinatesOffset = 50
          this.SET_MENU_COORDINATES({
            x: e.clientX - coordinatesOffset,
            y: e.clientY - coordinatesOffset
          })

          this.$nextTick(() => {
            this.SET_IS_MENU_DISPLAYED(true)
          })
        }
      },
      // Placing the input class before the other css classes
      // to prevent the block to have multiple inputs associated to a single output
      disableNodeOutput (nodesObj) {
        const outputCssClass = nodesObj.output_class

        const element = document.getElementsByClassName(outputCssClass)[ 0 ]

        // Placing the input class before the other css classes
        // to prevent the block to have multiple inputs associated to a single output
        element.classList.remove('output', outputCssClass)
        element.classList.add('input', 'output', outputCssClass)
      },
      // Revert the changes made by the disableNodeOutput method
      enableNodeOutput (nodesObj) {
        const element = document.getElementsByClassName(nodesObj.output_class)[ 0 ]
        if (element) element.classList.remove('input')
      }
    }
  }
</script>

<style scoped>

</style>
